import { render, staticRenderFns } from "./BindLb.vue?vue&type=template&id=059bfb4a"
import script from "./BindLb.vue?vue&type=script&lang=js"
export * from "./BindLb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports